import keyMirror from 'keymirror'

export default keyMirror({
  GET_CONFIG_PER_TEMPLATES_REQUEST: null,
  GET_CONFIG_PER_TEMPLATES_SUCCESS: null,
  GET_CONFIG_PER_TEMPLATES_FAILED: null,

  ADD_CONFIG_PER_TEMPLATE_REQUEST: null,
  ADD_CONFIG_PER_TEMPLATE_SUCCESS: null,
  ADD_CONFIG_PER_TEMPLATE_FAILED: null,

  GET_CONFIG_PER_TEMPLATE_DETAIL_REQUEST: null,
  GET_CONFIG_PER_TEMPLATE_DETAIL_SUCCESS: null,
  GET_CONFIG_PER_TEMPLATE_DETAIL_FAILED: null,

  UPDATE_CONFIG_PER_TEMPLATE_REQUEST: null,
  UPDATE_CONFIG_PER_TEMPLATE_SUCCESS: null,
  UPDATE_CONFIG_PER_TEMPLATE_FAILED: null,

  DELETE_CONFIG_PER_TEMPLATE_REQUEST: null,
  DELETE_CONFIG_PER_TEMPLATE_SUCCESS: null,
  DELETE_CONFIG_PER_TEMPLATE_FAILED: null
})
